import React from "react";
import Index from "../../Index";
import { DataService } from "../../../config/DataService";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { userContactUs } from "../../../redux/features/slices/User/UserService";
import { contactUsValidationSchema } from "../../../validation/UserValidation";

export default function Footer() {
  const dispatch = useDispatch();
  const userToken = useSelector((store) => store.user.userToken);

  let initialValues = {
    name: "",
    email: "",
    message: "",
  };

  return (
    <>
      <Index.Box className="footer-main-content">
        <Index.Box className="pd-footer-details">
          <Index.Box className="container">
            <Index.Box className="contact-us-details">
              <Index.Typography
                className="contactus-title-shadow"
                variant="h4"
                component="h4"
              >
                Contact us
              </Index.Typography>
              <Index.Typography
                className="contactus-title"
                variant="h4"
                component="h4"
              >
                Contact us
              </Index.Typography>
            </Index.Box>
          </Index.Box>
          <Index.Box className="footer-pos-main">
            <Index.Box className="container">
              <Index.Box className="grid-row footer-row">
                <Index.Box sx={{ width: 1 }} className="grid-main footer-main">
                  <Index.Box
                    display="grid"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={{ xs: 2, sm: 2, md: 0, lg: 0 }}
                    className="footer-grid"
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6",
                      }}
                      className="grid-column footer-column"
                    >
                      <Index.Box className="footer-left-content">
                        <Index.Box className="footer-bg-rounded">
                          <Index.Box className="rounde-footer-inner-details">
                            <Index.Box className="footer-logo">
                              <Index.Link className="redirect-footer-logo">
                                <img
                                  alt="footer-logo"
                                  className="footer-logo"
                                  src={Index.Svg.logo}
                                ></img>
                              </Index.Link>
                            </Index.Box>
                            <Index.Box className="address-footer-main">
                              <Index.List className="footer-add-ul">
                                <Index.ListItem className="footer-add-li">
                                  <Index.Box className="add-icon-main-footer">
                                    <img
                                      src={Index.Svg.call}
                                      className="footer-add-icons"
                                      alt=""
                                    ></img>
                                  </Index.Box>
                                  <Index.Typography
                                    className="add-footer-title"
                                    component="p"
                                    variant="p"
                                  >
                                    {/* 309-798-4145 */}
                                    Coming soon...
                                  </Index.Typography>
                                </Index.ListItem>
                                <Index.ListItem className="footer-add-li">
                                  <Index.Box className="add-icon-main-footer">
                                    <img
                                      src={Index.Svg.pin}
                                      className="footer-add-icons"
                                      alt=""
                                    ></img>
                                  </Index.Box>
                                  <Index.Typography
                                    className="add-footer-title"
                                    component="p"
                                    variant="p"
                                  >
                                    {/* 1377 Simpson Street Edgington, IL 61284 */}
                                    Coming soon...
                                  </Index.Typography>
                                </Index.ListItem>
                              </Index.List>
                            </Index.Box>
                            <Index.Box className="footer-social-icon-main">
                              <Index.Typography
                                component="p"
                                variant="p"
                                className="visit-social-title"
                              >
                                Visit Us
                              </Index.Typography>
                              <Index.List className="footer-social-icon-ul">
                                <Index.ListItem className="footer-social-icon-li">
                                  <Index.Link
                                    className="social-redirect-link"
                                    to="https://www.facebook.com/profile.php?id=100093036447824"
                                    target="_blank"
                                  >
                                    <img
                                      src={Index.Svg.facebook}
                                      className="social-icon-img"
                                      alt=""
                                    ></img>
                                  </Index.Link>
                                </Index.ListItem>
                                <Index.ListItem className="footer-social-icon-li">
                                  <Index.Link
                                    className="social-redirect-link"
                                    to="https://www.instagram.com/fitrizerhealth/"
                                    target="_blank"
                                  >
                                    <img
                                      src={Index.Svg.instagram}
                                      className="social-icon-img"
                                      alt=""
                                    ></img>
                                  </Index.Link>
                                </Index.ListItem>
                                <Index.ListItem className="footer-social-icon-li">
                                  <Index.Link
                                    className="social-redirect-link"
                                    to="https://t.me/Fitrizer"
                                    target="_blank"
                                  >
                                    <img
                                      // src={Index.Svg.telegram}
                                      className="social-icon-img"
                                      alt=""
                                    ></img>
                                  </Index.Link>
                                </Index.ListItem>
                                <Index.ListItem className="footer-social-icon-li">
                                  <Index.Link
                                    className="social-redirect-link"
                                    to="https://twitter.com/FitrizerHealth"
                                    target="_blank"
                                  >
                                    <img
                                      src={Index.Svg.twitter}
                                      className="social-icon-img"
                                      alt=""
                                    ></img>
                                  </Index.Link>
                                </Index.ListItem>
                              </Index.List>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="svg-rounded-border">
                            <img
                              src={Index.Svg.footerline}
                              className="footer-line-bg"
                              alt=""
                            ></img>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6",
                      }}
                      className="grid-column footer-column"
                    >
                      <Index.Box className="footer-right-content">
                        <Index.Box className="footer-details-main"></Index.Box>
                        <Index.Box className="footer-form-details">
                          <Formik
                            enableReinitialize
                            onSubmit={async (values, { resetForm }) => {
                              DataService.defaults.headers.common["auth"] =
                                userToken;

                              const data = {
                                values: values,
                                userToken: userToken,
                              };
                              dispatch(userContactUs(data))
                                .then((res) => {
                                  if (res?.payload?.data?.status === 201) {
                                    toast.success("Request sent successfully");
                                    resetForm({ values: "" });
                                  }
                                })
                                .catch((error) => {
                                  toast.error(error.response.data.message);
                                });
                            }}
                            initialValues={initialValues}
                            validationSchema={contactUsValidationSchema}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                            }) => (
                              <form onSubmit={handleSubmit}>
                                <Index.Box
                                  display="grid"
                                  gridTemplateColumns="repeat(12, 1fr)"
                                  gap={{ xs: 0, sm: 0, md: 0, lg: 0 }}
                                  className="footer-grid"
                                >
                                  <Index.Box
                                    gridColumn={{
                                      xs: "span 12",
                                      sm: "span 12",
                                      md: "span 6",
                                      lg: "span 6",
                                    }}
                                    className="grid-column footer-column"
                                  >
                                    <Index.Box className="input-box custom-form-details">
                                      <Index.Box className="form-group custom-group">
                                        <Index.FormHelperText className="form-label">
                                          Name
                                        </Index.FormHelperText>
                                        <Index.TextField
                                          fullWidth
                                          id="fullWidth"
                                          className="form-control custom-control"
                                          name="name"
                                          value={values.name}
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          helperText={
                                            touched.name && errors.name
                                          }
                                          error={Boolean(
                                            errors.name && touched.name
                                          )}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box
                                    gridColumn={{
                                      xs: "span 12",
                                      sm: "span 12",
                                      md: "span 6",
                                      lg: "span 6",
                                    }}
                                    className="grid-column footer-column"
                                  >
                                    <Index.Box className="input-box custom-form-details">
                                      <Index.Box className="form-group custom-group">
                                        <Index.FormHelperText className="form-label">
                                          Email
                                        </Index.FormHelperText>
                                        <Index.TextField
                                          fullWidth
                                          id="fullWidth"
                                          className="form-control custom-control"
                                          name="email"
                                          value={values.email}
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          helperText={
                                            touched.email && errors.email
                                          }
                                          error={Boolean(
                                            errors.email && touched.email
                                          )}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box
                                    gridColumn={{
                                      xs: "span 12",
                                      sm: "span 12",
                                      md: "span 12",
                                      lg: "span 12",
                                    }}
                                    className="grid-column footer-column"
                                  >
                                    <Index.Box className="input-box custom-form-details">
                                      <Index.Box className="form-group custom-group">
                                        <Index.FormHelperText className="form-label">
                                          Write Message
                                        </Index.FormHelperText>
                                        <Index.TextareaAutosize
                                          as="textarea"
                                          rows={4}
                                          onBlur={handleBlur}
                                          name="message"
                                          value={values.message}
                                          onChange={handleChange}
                                          helperText={
                                            touched.email && errors.email
                                          }
                                          error={Boolean(
                                            errors.email && touched.email
                                          )}
                                          className="form-control text-custom-control"
                                        ></Index.TextareaAutosize>
                                      </Index.Box>
                                      {touched.message && errors.message && (
                                        <Index.FormHelperText error>
                                          {errors.message}
                                        </Index.FormHelperText>
                                      )}
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box
                                    gridColumn={{
                                      xs: "span 12",
                                      sm: "span 12",
                                      md: "span 12",
                                      lg: "span 12",
                                    }}
                                    className="grid-column footer-column"
                                  >
                                    <Index.Box className="send-footer-btn">
                                      <Index.PrimaryButton
                                        type="submit"
                                        className="comman-primary-btn"
                                        btnLabel="Send"
                                      />
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </form>
                            )}
                          </Formik>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      <Index.Box className="bottom-bg-footer">
        <Index.Box className="container">
          <Index.Box className="pd-footer-copy">
            <Index.Grid container>
              <Index.Grid item md={4}>
                <Index.Link
                  component="p"
                  variant="p"
                  className="footer-about-title"
                  to={"/about-us"}
                >
                  About Us
                </Index.Link>
              </Index.Grid>
              <Index.Grid item md={4}>
                <Index.Typography
                  component="p"
                  variant="p"
                  className="copyright-title"
                >
                  All Rights Reserved ©2023 Fitrizer
                </Index.Typography>
              </Index.Grid>
              <Index.Grid item md={4}>
                <Index.Box className="footer-link">
                  <Index.Link
                    component="p"
                    variant="p"
                    className="copyright-title"
                    to={"/privacy-policy"}
                  >
                    Privacy Policy
                  </Index.Link>
                  <Index.Typography
                    component="p"
                    variant="p"
                    className="copyright-title"
                  >
                    |
                  </Index.Typography>
                  <Index.Link
                    component="p"
                    variant="p"
                    className="copyright-title"
                    to={"/terms-condition"}
                  >
                    Terms Condition
                  </Index.Link>
                </Index.Box>
              </Index.Grid>
            </Index.Grid>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
}
